export default "__VITE_ASSET__48fc57a9__"